import { Icon } from '@tallink/components-lib'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { getSummary } from '../../selectors/selectors'
import LoadingPrice from './LoadingPrice'
import s from './TotalPrice.module.scss'

export default function TotalPrice({ detailedPriceOpened }) {
  const { t } = useTranslation()
  const { price } = useSelector(getSummary)

  return (
    <div className={s['total-price']}>
      <div className={s['brackets-and-description']}>
        <Brackets detailedPriceOpened={detailedPriceOpened} />
        <div className={s['price-description']}>{t('price.total')}:</div>
      </div>
      <LoadingPrice price={price} />
    </div>
  )
}

TotalPrice.propTypes = {
  detailedPriceOpened: PropTypes.bool.isRequired
}

function Brackets({ detailedPriceOpened }) {
  return (
    <div className={s.brackets}>
      <Icon className={classNames({ [s['reversed-bracket']]: detailedPriceOpened })} type="arrow-left" />
      <Icon className={classNames({ [s['reversed-bracket']]: !detailedPriceOpened })} type="arrow-left" />
    </div>
  )
}

Brackets.propTypes = {
  detailedPriceOpened: PropTypes.bool.isRequired
}
